import { Navigate, Route, Routes } from 'react-router';
import { CabsCallbackPage } from './pages/CabsCallbackPage.tsx';
import { LoadingRegion } from '@gatecheckpro/design-system';
import { useSession } from './lib/session.tsx';
import { SignInPage } from './pages/SignInPage.tsx';
import { ConsoleLayout } from './pages/ConsoleLayout.tsx';
import { OnboardingQueuePage } from './pages/OnboardingQueuePage.tsx';
import { OrganizationReviewPage } from './pages/OrganizationReviewPage.tsx';
import { AuditPage } from './pages/AuditPage.tsx';
import { CapabilityGrantsPage } from './pages/CapabilityGrantsPage.tsx';
import { NoCapabilityPage } from './pages/NoCapabilityPage.tsx';
import { FinanceReconciliationPage } from './pages/FinanceReconciliationPage.tsx';
import { PaymentExceptionsPage } from './pages/PaymentExceptionsPage.tsx';

export function App() {
  const { state } = useSession();

  if (state.status === 'loading') {
    return (
      <main className="gc-auth">
        <div className="gc-auth__card">
          <LoadingRegion label="Opening the console" />
        </div>
      </main>
    );
  }

  if (state.status === 'anonymous') {
    return (
      <Routes>
        {/*
          Before the catch-all: this origin's CABS callback is a real page, not another way of
          showing the sign-in form. Public for the same reason as the organizer's.
        */}
        <Route path="/auth/cabs/callback" element={<CabsCallbackPage />} />
        <Route path="*" element={<SignInPage />} />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route element={<ConsoleLayout />}>
        <Route path="/" element={<NoCapabilityPage />} />
        <Route path="/onboarding" element={<OnboardingQueuePage />} />
        <Route path="/onboarding/:organizationId" element={<OrganizationReviewPage />} />
        <Route path="/payment-exceptions" element={<PaymentExceptionsPage />} />
        <Route path="/finance-reconciliation" element={<FinanceReconciliationPage />} />
        <Route path="/audit" element={<AuditPage />} />
        <Route path="/capability-grants" element={<CapabilityGrantsPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
